import axios, { AxiosError } from 'axios';
import { GatewayV2Types } from '../../services/gatewayV2/gatewayV2.types';

export class GatewayV2Provider {
    constructor(protected path: string) {}

    get prefix() {
        return `${this.path}/gw2`;
    }

    public preApprovalsSearch = async (data: Pick<GatewayV2Types.PreApprovalsSearchRequest, 'isFullProfile'>) => {
        try {
            await axios.post<void>(`${this.prefix}/pre-approvals-search/`, data, {
                withCredentials: true,
            });
        } catch (e) {
            return null;
        }
    };

    public getStatusesV2 = async () => {
        const { data } = await axios.get<GatewayV2Types.StatusesV2Response>(`${this.prefix}/statuses-v2/`, {
            withCredentials: true,
        });
        return data;
    };

    public sendApplicationV2 = async (request: GatewayV2Types.LoansApplicationV2ClientRequest) => {
        try {
            const { data } = await axios.post<GatewayV2Types.LoansApplicationV2Response>(
                `${this.prefix}/application/`,
                request,
                {
                    withCredentials: true,
                },
            );
            return data;
        } catch (e) {
            return null;
        }
    };

    public getDeliverySlots = async (offerId: string) => {
        const { data } = await axios.get<GatewayV2Types.GetDeliverySlotsResponse>(`${this.prefix}/delivery-slots/`, {
            withCredentials: true,
            params: {
                offerId,
            },
        });
        return data;
    };

    public updateDeliveryAddress = async (data: GatewayV2Types.UpdateDeliveryAddressRequest) => {
        try {
            await axios.post<void>(`${this.prefix}/update-delivery-address/`, data, {
                withCredentials: true,
            });
            return true;
        } catch (e) {
            return false;
        }
    };

    public selectDeliverySlot = async (data: GatewayV2Types.SelectDeliverySlotRequest) => {
        try {
            await axios.post<void>(`${this.prefix}/select-delivery-slot/`, data, {
                withCredentials: true,
            });
            return true;
        } catch (e) {
            return false;
        }
    };

    public sendDeliveryConfirmation = async (
        request: GatewayV2Types.DeliveryConfirmationRequest,
    ): Promise<GatewayV2Types.TConfirmationRequestResponse> => {
        try {
            const { data } = await axios.post<GatewayV2Types.TConfirmationRequestResponse>(
                `${this.prefix}/delivery-confirmation/`,
                request,
                {
                    withCredentials: true,
                },
            );
            return data;
        } catch (error: unknown) {
            const axiosError = error as AxiosError;

            return {
                statusCode: (axiosError.response?.status as GatewayV2Types.DeliveryConfirmationResponseCodes) || 500,
            };
        }
    };

    public sendDeliveryConfirmationSubmit = async (request: GatewayV2Types.DeliveryConfirmationSubmitRequest) => {
        try {
            const { data } = await axios.post<GatewayV2Types.DeliveryConfirmationSubmitResponse>(
                `${this.prefix}/delivery-confirmation-submit/`,
                request,
                {
                    withCredentials: true,
                },
            );
            return {
                verified: data.verified,
                statusCode: 200,
            };
        } catch (error: unknown) {
            const axiosError = error as AxiosError;

            return {
                verified: false,
                statusCode: axiosError.response?.status || 500,
            };
        }
    };

    public getPreApprovalIframeInfo = async (offerId: string) => {
        const { data } = await axios.get<GatewayV2Types.PreApprovalIframeInfoResponse>(
            `${this.prefix}/pre-approval-iframe-info/`,
            {
                withCredentials: true,
                params: {
                    offerId,
                },
            },
        );
        return data;
    };
}
